import { z } from "zod"

export const Locale = {
  es_ES: "es_ES",
  en_US: "en_US",
} as const

export const EmployeeCompanySchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  logo: z.string().nullable(),
})

export const EmployeeSchema = z.object({
  id: z.bigint().transform(String),
  email: z.string(),
  name: z.string().nullable(),
  locale: z.enum(Locale),
  avatar: z.string().nullable(),
  isOwner: z.boolean(),
  isManager: z.boolean(),
  companies: z.array(EmployeeCompanySchema),
  createdAt: z.date().transform((value) => value.toISOString()),
  archivedAt: z
    .date()
    .nullable()
    .transform((value) => (value ? value.toISOString() : null)),
  lastLoginAt: z
    .date()
    .nullable()
    .transform((value) => (value ? value.toISOString() : null)),
})
export type EmployeeResponseData = z.infer<typeof EmployeeSchema>

export const EmployeesSchema = z.array(EmployeeSchema)
export type EmployeesResponseData = z.infer<typeof EmployeesSchema>

export const EmployeeInviteSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  email: z.string(),
  createdAt: z.date().transform((value) => value.toISOString()),
})
export type EmployeeInviteResponseData = z.infer<typeof EmployeeInviteSchema>

export const EmployeeInvitesSchema = z.array(EmployeeInviteSchema)
export type EmployeeInvitesResponseData = z.infer<typeof EmployeeInvitesSchema>
